import React, { Component } from "react";
import { connect } from "react-redux";
/**
 * HOC that Handles whether or not the user is allowed to see the page.
 * @param allowedRoles (array) - user roles that are allowed to see the page.
 * @return {function(*): {new(*=): Component}}
 * @constructor
 */
const ProtectedRouteHOC = (allowedRoles) => (WrappedComponent) => {
  class WithAuthorization extends Component {
    constructor(props) {
      super(props);

      // Get from Redux
      this.state = {
        user: {
          name: "undefined",
          role: "public",
        },
      };
    }

    render() {
      const { role } = this.state.user;
      const { errorMessage, errorCode } = this.props;
      const isRoleMatch = allowedRoles.includes(role);

      if (isRoleMatch && errorCode < 1) {
        return <WrappedComponent {...this.props} />;
      } else if (!isRoleMatch) {
        return (
          <h3>
            <p>
              <i className="fa fa-warning yellow" />
              You do not have permission to view this page. You will be
              redirected to the login page
            </p>
          </h3>
        );
      } else {
        return (
          <div>
            <h3>
              <p>
                <i className="fa fa-warning yellow" />
                Fatal error: {errorCode} {errorMessage}
              </p>
            </h3>
            <WrappedComponent {...this.props} />
          </div>
        );
      }
    }
  }

  const mapStateToProps = (state) => {
    return {
      errorCode: state.ErrorReducer.errorCode,
      errorMessage: state.ErrorReducer.errorMessage,
    };
  };

  return connect(mapStateToProps, null)(WithAuthorization);
};

export default ProtectedRouteHOC;



// WEBPACK FOOTER //
// ./src/modules/NTICore/component/HOC/ProtectedRouteHOC.js